import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';

import { Link } from 'react-router';
import styles from './footer.css';

const { footer, ul, li, a, div } = hh(h);

const copyrightHTML = `&copy; Code at Uni ${new Date().getFullYear()}`;

const Footer = () => (
    footer({className: styles.footer}, [
        ul({className: styles.list}, [
            li({className: styles.leftItem}, [
              h(Link, {to: '/faqs', className: styles.link, activeClassName: styles.active}, 'FAQs')
            ]),
            li({className: styles.leftItem}, [
              a({target: '_blank', href: 'https://github.com/code-at-uni', className: styles.link}, 'Resources')]),
            li({className: styles.leftItem}, [
              a({target: '_blank', href: 'https://www.linkedin.com/school/5360395/alumni', className: styles.link}, 'Alumni')]),
            li({className: styles.leftItem}, [
              a({target: '_blank', href: 'https://angel.co/code-at-uni/jobs', className: styles.link}, 'Jobs')])
          ]),
        ul({className: styles.list}, [
            li({className: styles.rightItem}, [
                a({target: '_blank', href: 'https://medium.com/code-at-uni', className: styles.medium}, 'Blog')]),
            li({className: styles.rightItem}, [
                a({target: '_blank', href: 'https://www.instagram.com/codeatuni/', className: styles.instagram}, 'Instagram')]),
            li({className: styles.rightItem}, [
                a({target: '_blank', href: 'https://twitter.com/codeatuni', className: styles.medium}, 'Twitter')]),
            li({className: styles.rightItem}, [
                a({target: '_blank', href: 'https://www.facebook.com/CodeatUni1', className: styles.facebook}, 'Facebook')])
          ]),
        div({ className: styles.lastLine, dangerouslySetInnerHTML: { __html: copyrightHTML } })
    ])
);

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/Footer/index.js
 **/